module.exports = __webpack_public_path__ + "img/fssdyrm.f5f8c1a2.png";